import DefaultLink from '@/components/common/default/DefaultLink';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { CommonEnum } from '@/types/translations/CommonEnum';
import Image from 'next/image';
import Link from 'next/link';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Virtual } from 'swiper/modules';
import uiItems from '@/constants/ui-items/index.constants';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useRef } from 'react';

export default function IndexPopularBrands() {
  const { translate: translateCommon } = useTypedTranslation<CommonEnum>('common');
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);

  return (
    <div>
      <div className="tw-flex tw-items-center tw-justify-between tw-pb-4 max-nine:tw-px-4">
        <h2 className="tw-relative tw-w-fit tw-font-plusJakartaSans tw-text-2xl tw-font-semibold tw-text-text max-nine:tw-text-lg">
          {translateCommon(CommonEnum['popular_brands'])}
          <hr
            aria-hidden="true"
            className="tw-absolute tw-mt-1 tw-h-[5px] tw-w-[80%] tw-rounded-full tw-border-none tw-bg-custom-gold tw-opacity-100 max-nine:tw-h-[3px]"
          />
        </h2>
        <div className="tw-flex tw-items-center tw-justify-end">
          <DefaultLink
            href="/brands"
            className="tw-font-plusJakartaSans tw-text-base tw-font-semibold tw-text-textBlack"
          >
            {translateCommon(CommonEnum['view_more'])}
          </DefaultLink>
        </div>
      </div>
      <div className="tw-relative tw-w-full max-nine:tw-pl-4">
        <Swiper
          modules={[Virtual]}
          breakpoints={{
            0: {
              slidesPerView: 1.2,
              spaceBetween: 10,
            },
            350: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            450: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 3,
              spaceBetween: 25,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 31,
            },
          }}
          loop={false}
          className="tw-h-[130px]"
        >
          {uiItems.indexItems.popularBrands.map(({ name, image, href }, index) => (
            <SwiperSlide key={name} virtualIndex={index}>
              <Link
                href={href}
                className="tw-flex tw-h-[122px] tw-items-center tw-justify-center tw-rounded-[13px] tw-border-2 tw-border-solid tw-border-custom-gray tw-bg-white tw-p-6 tw-no-underline tw-shadow-md"
              >
                <Image
                  src={image}
                  alt={name}
                  width={206}
                  height={74}
                  className="tw-aspect-video tw-h-full tw-w-full tw-object-contain"
                />
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
